import { createFileRoute, notFound } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { canCurrentProfileConfigureEnterprise, isCurrentProfileAdmin } from '@mews-commander/legacy-entities';
import { PropertiesTable } from '@mews-commander/modules/src/modules/enterpriseRelationships';
import { OptimusProvider } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/EnterpriseRelationshipReport/Index/')({
    beforeLoad: ({ context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED } }) => {
        const state = getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED();
        const privilege = isCurrentProfileAdmin(state) || canCurrentProfileConfigureEnterprise(state);
        if (!privilege) {
            throw notFound();
        }
    },
    component: () => (
        <OptimusProvider density="spacious">
            <PropertiesTable guideLink={createGuideLink(ArticlePath.SetUpPortfolio)} />
        </OptimusProvider>
    ),
    staticData: {
        title: TextKey.PropertiesNavigation,
        routeName: RouteName.EnterpriseRelationshipReportIndex,
        owner: MewsTeam.MultiProperty,
        type: RouteType.Frontend,
    },
});
